import { createSelector } from "reselect";
import { IchatInitialState } from "./types";

export const stateSelector = (state: any): IchatInitialState => state.chatReducerV2;
export const allMessagesSelector = createSelector(stateSelector, (state) => state.allMessages);
export const unreadValSelector = createSelector(stateSelector, (state) => state.unreadValue);
export const isMessagesLoadingSelector = createSelector(stateSelector, (state) => state.isLoading);
export const maxCountSelector = createSelector(stateSelector, (state) => state.maxCount);
export const unreadCountSelector = createSelector(stateSelector, (state) => state.unreadCount);
export const isChatV2ConnectedSelector = createSelector(stateSelector, (state) => state.isChatV2Connected);